import React from "react"
import PropTypes from "prop-types"
import cloudinary from "cloudinary-core"
import { AssetSummary, LocationSummary } from "@swipesense/asset-components"
import AssetHistoryModal from "../AssetHistoryModal"
import "./AssetItemCard.scss"

const AssetItemCard = ({
  item: {
    id,
    name,
    assetId,
    modelName,
    serialNumber,
    manufacturer,
    ownership,
    lastMovedAt,
    location,
    owners,
    imageId,
  },
  deviceType,
  isStationary,
  timeStationary,
  timeSinceDetected,
  isMissing,
  style,
}) => {
  // image-related code
  const cloudinaryCore = new cloudinary.Cloudinary({
    cloud_name: "swipesense-inc",
  })
  const fallbackUrl = "/icons/fallback.svg"
  const desktopPhotoUrl = imageId
    ? cloudinaryCore.url(imageId, {
        width: 119,
        height: 119,
        crop: "fill",
      })
    : fallbackUrl
  const mobilePhotoUrl = imageId
    ? cloudinaryCore.url(imageId, {
        width: 60,
        height: 60,
        crop: "fill",
      })
    : fallbackUrl

  const idle = timeSinceDetected === null || location === null || isMissing

  const assetInfo = {
    assetId: assetId,
    desktopPhotoUrl: desktopPhotoUrl,
    deviceType: deviceType,
    fallbackUrl: fallbackUrl,
    id: id,
    idle: idle,
    lastMovedAt: lastMovedAt,
    location: location,
    manufacturer: manufacturer,
    mobilePhotoUrl: mobilePhotoUrl,
    modelName: modelName,
    name: name,
    owners: owners,
    ownership: ownership,
    serialNumber: serialNumber,
    timeSinceDetected: timeSinceDetected,
  }

  const locationInfo = {
    deviceType: deviceType,
    idle: idle,
    isMissing: isMissing,
    isStationary: isStationary,
    locationType: location && location.locationType,
    name: location && location.name,
    timeSinceDetected: timeSinceDetected,
    timeStationary: timeStationary,
    unit: location && location.unit,
  }

  return (
    <div className={"AssetItemCard " + deviceType} style={style}>
      <AssetSummary {...assetInfo} />
      <LocationSummary
        {...locationInfo}
        childProp={<AssetHistoryModal asset={assetInfo} />}
      />
    </div>
  )
}

AssetItemCard.propTypes = {
  timeStationary: PropTypes.number,
  isStationary: PropTypes.bool,
  timeSinceDetected: PropTypes.number,
  isMissing: PropTypes.bool,
  style: PropTypes.object,
  deviceType: PropTypes.string,
  item: PropTypes.shape({
    assetId: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    serialNumber: PropTypes.string,
    manufacturer: PropTypes.string,
    modelName: PropTypes.string,
    ownership: PropTypes.string,
    lastMovedAt: PropTypes.string,
    location: PropTypes.shape({
      id: PropTypes.string,
      locationType: PropTypes.string,
      name: PropTypes.string,
      patientArea: PropTypes.bool,
      unit: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      }).isRequired,
    }),
    owners: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string })),
    imageId: PropTypes.string,
  }),
}

export default AssetItemCard
